const RadarChart = ({ data }) => {
  const size = 150;
  const center = size / 2;
  const maxRadius = (size / 2) - 20;

  // Calculate points for the 4-point radar (Front, Right, Back, Left)
  const points = [
    { label: "Front", value: data.front, angle: -90 },
    { label: "Right", value: data.right, angle: 0 },
    { label: "Back", value: data.back, angle: 90 },
    { label: "Left", value: data.left, angle: 180 },
  ];

  // Calculate polygon points
  const polygonPoints = points.map((point) => {
    const radius = (point.value / 100) * maxRadius;
    const x = center + radius * Math.cos((point.angle * Math.PI) / 180);
    const y = center + radius * Math.sin((point.angle * Math.PI) / 180);
    return `${x},${y}`;
  }).join(" ");

  // Grid circles
  const gridCircles = [25, 50, 75, 100];

  return (
    <div className="flex flex-col items-center" data-testid="radar-chart">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* Grid circles */}
        {gridCircles.map((level) => (
          <circle
            key={level}
            cx={center}
            cy={center}
            r={(level / 100) * maxRadius}
            className="radar-grid"
            fill="none"
            stroke="#262626"
            strokeWidth="1"
          />
        ))}

        {/* Axis lines */}
        {points.map((point, i) => {
          const x = center + maxRadius * Math.cos((point.angle * Math.PI) / 180);
          const y = center + maxRadius * Math.sin((point.angle * Math.PI) / 180);
          return (
            <line
              key={i}
              x1={center}
              y1={center}
              x2={x}
              y2={y}
              stroke="#262626"
              strokeWidth="1"
            />
          );
        })}

        {/* Data polygon */}
        <polygon
          points={polygonPoints}
          className="radar-polygon"
          fill="rgba(204, 255, 0, 0.2)"
          stroke="#CCFF00"
          strokeWidth="2"
        />

        {/* Data points */}
        {points.map((point, i) => {
          const radius = (point.value / 100) * maxRadius;
          const x = center + radius * Math.cos((point.angle * Math.PI) / 180);
          const y = center + radius * Math.sin((point.angle * Math.PI) / 180);
          return (
            <circle
              key={i}
              cx={x}
              cy={y}
              r="4"
              className="radar-point"
              fill="#CCFF00"
            />
          );
        })}

        {/* Labels */}
        {points.map((point, i) => {
          const labelRadius = maxRadius + 15;
          const x = center + labelRadius * Math.cos((point.angle * Math.PI) / 180);
          const y = center + labelRadius * Math.sin((point.angle * Math.PI) / 180);
          return (
            <text
              key={i}
              x={x}
              y={y}
              textAnchor="middle"
              dominantBaseline="middle"
              fill="#A3A3A3"
              fontSize="9"
              fontFamily="JetBrains Mono"
              className="uppercase"
            >
              {point.label[0]}
            </text>
          );
        })}
      </svg>

      {/* Values display */}
      <div className="mt-2 grid grid-cols-4 gap-2 text-center w-full">
        {points.map((point) => (
          <div key={point.label} className="text-center">
            <span className="font-mono text-[10px] text-[#A3A3A3] uppercase block">
              {point.label}
            </span>
            <span className="font-heading font-bold text-sm text-white">
              {point.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RadarChart;
